import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.content = this.element.dataset.tooltipContent || this.element.getAttribute("title")
    if (!this.content) return

    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
    this.positionTooltip = this.positionTooltip.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    this.element.removeAttribute("title")

    this.element.addEventListener("mouseenter", this.showTooltip)
    this.element.addEventListener("mouseleave", this.hideTooltip)
    this.element.addEventListener("focus", this.showTooltip)
    this.element.addEventListener("blur", this.hideTooltip)
    this.element.addEventListener("click", this.showTooltip)
    this.element.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    this.element.removeEventListener("mouseenter", this.showTooltip)
    this.element.removeEventListener("mouseleave", this.hideTooltip)
    this.element.removeEventListener("focus", this.showTooltip)
    this.element.removeEventListener("blur", this.hideTooltip)
    this.element.removeEventListener("click", this.showTooltip)
    this.element.removeEventListener("keydown", this.handleKeydown)
    window.removeEventListener("scroll", this.positionTooltip, true)
    window.removeEventListener("resize", this.positionTooltip)
    this.tooltipElement?.remove()
    this.tooltipElement = null
    this.element.removeAttribute("aria-describedby")
  }

  showTooltip() {
    if (this.tooltipElement) return

    this.tooltipElement = document.createElement("div")
    this.tooltipElement.id = `tooltip-${Math.random().toString(36).slice(2)}`
    this.tooltipElement.setAttribute("role", "tooltip")
    this.tooltipElement.className = "tooltip show pointer-events-none fixed z-[120] max-w-xs whitespace-pre-line rounded-lg bg-slate-900 px-3 py-2 text-left text-xs font-medium leading-5 text-white shadow-lg"
    this.tooltipElement.textContent = this.content
    document.body.appendChild(this.tooltipElement)
    this.element.setAttribute("aria-describedby", this.tooltipElement.id)

    this.positionTooltip()
    window.addEventListener("scroll", this.positionTooltip, true)
    window.addEventListener("resize", this.positionTooltip)
  }

  hideTooltip() {
    window.removeEventListener("scroll", this.positionTooltip, true)
    window.removeEventListener("resize", this.positionTooltip)
    this.tooltipElement?.remove()
    this.tooltipElement = null
    this.element.removeAttribute("aria-describedby")
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return

    this.hideTooltip()
    this.element.blur()
  }

  positionTooltip() {
    if (!this.tooltipElement) return

    const anchorRect = this.element.getBoundingClientRect()
    const tooltipRect = this.tooltipElement.getBoundingClientRect()
    const spacing = 10
    const top = Math.max(spacing, anchorRect.top - tooltipRect.height - spacing)
    const centeredLeft = anchorRect.left + (anchorRect.width / 2) - (tooltipRect.width / 2)
    const left = Math.min(
      Math.max(spacing, centeredLeft),
      window.innerWidth - tooltipRect.width - spacing
    )

    this.tooltipElement.style.top = `${top}px`
    this.tooltipElement.style.left = `${left}px`
  }
}
